module.exports = __webpack_public_path__ + "static/img/sign-2.04d0d69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Events/IndraDhanush/IndraDhanush-pics/sign-2.jpg
// module id = tUis
// module chunks = 0